import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import { I18nProvider } from "./contexts/I18nContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Dashboard from "./pages/Dashboard";
import Matters from "./pages/Matters";
import MatterDetail from "./pages/MatterDetail";
import NewAnalysis from "./pages/NewAnalysis";
import Pricing from "./pages/Pricing";
import BillingSuccess from "./pages/BillingSuccess";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import LegalPage from "./pages/LegalPage";
import PublicReportPage from "./pages/PublicReport";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/legal/:doc" element={<LegalPage />} />
              <Route path="/share/r/:token" element={<PublicReportPage />} />

              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/matters" element={<ProtectedRoute><Matters /></ProtectedRoute>} />
              <Route path="/matters/:id" element={<ProtectedRoute><MatterDetail /></ProtectedRoute>} />
              <Route path="/new-analysis" element={<ProtectedRoute><NewAnalysis /></ProtectedRoute>} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}
